import { Action, SquareState } from "./types";

export const SquareReducer = (state: SquareState, action: Action) => {
    switch (action.type) {
        case 'SET_ZIPCODE':
            return { ...state, zipCode: action.payload };
        case 'SET_SQUARE':
            return { ...state, squareId: action.payload };
        case 'SET_OFFERCLASSIFICATION':
            return { ...state, offerClassificationId: action.payload };
        case 'SET_STATE':
            return { ...action.payload };
        default:
            return state;
    }
}